import { Pipe, PipeTransform } from '@angular/core';
import Highcharts from 'highcharts';
import { ChartOptionsBuilder } from './chart-options-builder';

function labelFormatter(): string {
  return `<table><tbody><tr><td><span>${this.name}<span></td><td><span>${Highcharts.numberFormat(
    this['y'],
    2
  )} %</span></td></tr></tbody></table>`;
}

function tooltipFormatter(): string {
  return `${Highcharts.numberFormat(this['y'], 2)}`;
}

function clickHandler(): boolean {
  return false;
}

@Pipe({
  name: 'legacyChartOptions',
  standalone: true,
})
export class LegacyChartOptionsPipe implements PipeTransform {
  transform(data: Highcharts.Options): Highcharts.Options {
    const isLineChart = data.chart.type.toUpperCase().includes('LINE');
    const isPieChart = data.chart.type.toUpperCase().includes('PIE');

    return new ChartOptionsBuilder({
      ...data,
      chart: {
        ...data.chart,
        styledMode: true,
        style: {
          ...data.chart?.style,
          fontFamily: 'Frutiger, Arial, sans-serif;',
          fontSize: '20px',
        },
        height: '300px',
      },
      plotOptions: {
        series: {
          ...data.plotOptions?.series,
          dataLabels: {
            ...data.plotOptions?.series?.dataLabels,
            enabled: isLineChart ? false : true,
            inside: false,
            crop: false,
            overflow: 'allow',
            allowOverlap: false,
            padding: 4,
            format: `{point.y:,.${2}f}`,
          },
          events: {
            ...data.plotOptions?.series?.events,
            legendItemClick: clickHandler,
          },
          marker: {
            ...data.plotOptions?.series?.marker,
            enabled: false,
          },
        },
        pie: isPieChart
          ? {
              ...data.plotOptions?.pie,
              dataLabels: {
                ...data.plotOptions?.pie?.dataLabels,
                enabled: false,
              },
              borderWidth: 0,
              showInLegend: true,
              point: {
                events: {
                  legendItemClick: clickHandler,
                },
              },
            }
          : undefined,
      },
      legend: {
        ...data.legend,
        symbolRadius: 0,
        borderWidth: 0,
        title: { text: undefined },
        floating: false,
        enabled: true,
        layout: 'vertical',
        verticalAlign: 'middle',
        align: 'right',
        useHTML: true,
        labelFormatter: labelFormatter,
      },
      tooltip: {
        ...data.tooltip,
        formatter: tooltipFormatter,
      },
      title: { text: undefined },
    })
      .removeAxisTitles()
      .mapSeries((series) => {
        return {
          ...series,
        }
      })
      .get();
  }
}

export const legacyOptionsTransformer = LegacyChartOptionsPipe.prototype.transform;
